var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.VCheckbox,{staticClass:"bk-checkbox",attrs:{"input-value":_vm.value,"value":_vm.value,"color":"var(--color-blue-800)","hide-details":"","label":_vm.label},on:{"change":function($event){return _vm.$emit('change', !!$event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }